import React from "react";
import { ServiceMemberDto } from "../../pages/types/types";
import YouthProfileExtension from "../service-extensions/youth/YouthProfileExtension";

interface ServiceProfileExtensionRendererProps {
  member: ServiceMemberDto;
}

const normalize = (value?: string) => (value ?? "").replace(/\s/g, "").toLowerCase();

export default function ServiceProfileExtensionRenderer({
  member,
}: ServiceProfileExtensionRendererProps) {
  const serviceName = normalize(member.serviceName);
  const memberTypes = member.memberTypes?.length ? member.memberTypes : [member.memberType];

  if (memberTypes.includes("PrimaryContact") && !memberTypes.includes("ServiceUser")) {
    return (
      <div className="service-member-extension-empty">
        Primary contact enrollment.
      </div>
    );
  }

  if (
    serviceName === "youthclub" ||
    serviceName.includes("youthclub")
  ) {
    return <YouthProfileExtension member={member} />;
  }

  return (
    <div className="service-member-extension-empty">
      No service-specific profile sections for this service.
    </div>
  );
}
